import type { NavProgress } from '../core/types';

/** One decision owns the illustration and camera; never borrow a later turn's lanes. */
export function junctionDecision(progress: NavProgress) {
  const fork = progress.fork;
  const div = progress.divergence;
  if (div && div.distance <= (fork?.distance ?? Infinity) && div.distance <= progress.distanceToManeuver) {
    return { distance: div.distance, step: null, lanes: div.lanes, advice: div.advice, kind: 'lanes' as const };
  }
  if (fork && fork.distance <= progress.distanceToManeuver) {
    return { distance: fork.distance, step: fork.step, lanes: fork.lanes, advice: fork.advice, kind: 'fork' as const };
  }
  return { distance: progress.distanceToManeuver, step: progress.maneuverStep, lanes: progress.lanes,
    advice: progress.laneAdvice, kind: 'turn' as const };
}

export function illustratedJunction(progress: NavProgress | null, _speedMs: number) {
  if (!progress || progress.offRoute) return null;
  const decision = junctionDecision(progress);
  const type = decision.step?.maneuver.type;
  const eligible = decision.kind !== 'turn' || type === 'fork' || type === 'off ramp' || type === 'on ramp';
  // A generous preparation window; the panel remains steady as distance counts down.
  // A fixed window prevents speed fluctuations from toggling the panel on/off.
  return eligible && decision.distance >= 0 && decision.distance <= 1000
    ? decision : null;
}
